var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.user
    ? _c(
        "sui-form",
        { attrs: { size: "small" } },
        [
          _c(
            "sui-grid",
            [
              _c(
                "sui-grid-row",
                { attrs: { centered: "" } },
                [
                  _c(
                    "sui-grid-column",
                    { attrs: { centered: "", width: 8 } },
                    [
                      _c(
                        "sui-header",
                        { tag: "h2", staticClass: "profile-info-header" },
                        [_vm._v("Personal info")]
                      ),
                      _c(
                        "sui-form-fields",
                        [
                          _c(
                            "sui-form-field",
                            [
                              _c("label", [_vm._v("First Name")]),
                              _c(
                                "sui-form-fields",
                                [
                                  _c(
                                    "sui-form-field",
                                    [
                                      _c("sui-dropdown", {
                                        attrs: {
                                          placeholder: "Salutation",
                                          selection: "",
                                          search: "",
                                          floating: "",
                                          options: _vm.salutations,
                                        },
                                        model: {
                                          value: _vm.user.salutation,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.user,
                                              "salutation",
                                              $$v
                                            )
                                          },
                                          expression: "user.salutation",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("sui-form-field", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.user.first_name,
                                          expression: "user.first_name",
                                        },
                                      ],
                                      attrs: {
                                        type: "text",
                                        placeholder: "First Name",
                                      },
                                      domProps: { value: _vm.user.first_name },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.user,
                                            "first_name",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("sui-form-field", [
                            _c("label", [_vm._v("Middle Name")]),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.user.middle_name,
                                  expression: "user.middle_name",
                                },
                              ],
                              attrs: {
                                type: "text",
                                name: "middle_name",
                                placeholder: "Middle Name",
                              },
                              domProps: { value: _vm.user.middle_name },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.user,
                                    "middle_name",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "sui-form-fields",
                        { attrs: { fields: "two" } },
                        [
                          _c("sui-form-field", { attrs: { width: "ten" } }, [
                            _c("label", [_vm._v("Last Name")]),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.user.last_name,
                                  expression: "user.last_name",
                                },
                              ],
                              attrs: {
                                type: "text",
                                name: "last_name",
                                placeholder: "Last Name",
                              },
                              domProps: { value: _vm.user.last_name },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.user,
                                    "last_name",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _c("sui-form-field", { attrs: { width: "six" } }, [
                            _c("label", [_vm._v("Suffix")]),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.user.suffix,
                                  expression: "user.suffix",
                                },
                              ],
                              attrs: {
                                type: "text",
                                name: "last_name",
                                placeholder: "Suffix",
                              },
                              domProps: { value: _vm.user.suffix },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.user,
                                    "suffix",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "sui-grid-row",
                { attrs: { centered: "" } },
                [
                  _c(
                    "sui-grid-column",
                    { attrs: { width: "four" } },
                    [
                      _c("sui-form-field", [
                        _c("label", [_vm._v("Company Name")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.user.profile.company,
                              expression: "user.profile.company",
                            },
                          ],
                          attrs: {
                            type: "text",
                            name: "title",
                            placeholder: "Company Name",
                          },
                          domProps: { value: _vm.user.profile.company },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.user.profile,
                                "company",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _c("sui-form-field", [
                        _c("label", [_vm._v("Title/Role")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.user.profile.title,
                              expression: "user.profile.title",
                            },
                          ],
                          attrs: {
                            type: "text",
                            name: "title",
                            placeholder: "Title/Role",
                          },
                          domProps: { value: _vm.user.profile.title },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.user.profile,
                                "title",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _c("sui-form-field", [
                        _c("label", [_vm._v("Department")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.user.profile.department,
                              expression: "user.profile.department",
                            },
                          ],
                          attrs: {
                            type: "text",
                            name: "department",
                            placeholder: "Department",
                          },
                          domProps: { value: _vm.user.profile.department },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.user.profile,
                                "department",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "sui-grid-column",
                    { attrs: { width: "four" } },
                    [
                      _c("sui-form-field", { attrs: { disabled: "" } }, [
                        _c("label", [_vm._v("Email")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.user.email,
                              expression: "user.email",
                            },
                          ],
                          attrs: {
                            type: "email",
                            name: "email",
                            placeholder: "Email",
                          },
                          domProps: { value: _vm.user.email },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(_vm.user, "email", $event.target.value)
                            },
                          },
                        }),
                      ]),
                      _c("sui-form-field", [
                        _c("label", [_vm._v("Mobile Phone")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.user.profile.mobile_phone,
                              expression: "user.profile.mobile_phone",
                            },
                          ],
                          attrs: {
                            type: "text",
                            name: "mobile",
                            placeholder: "Mobile Phone",
                          },
                          domProps: { value: _vm.user.profile.mobile_phone },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.user.profile,
                                "mobile_phone",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _c(
                        "sui-form-fields",
                        [
                          _c(
                            "sui-form-field",
                            { attrs: { width: "ten" } },
                            [
                              _c("label", [_vm._v("Phone")]),
                              _c("sui-form-field", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.user.profile.phone,
                                      expression: "user.profile.phone",
                                    },
                                  ],
                                  attrs: {
                                    type: "text",
                                    name: "phone",
                                    placeholder: "Phone",
                                  },
                                  domProps: { value: _vm.user.profile.phone },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.user.profile,
                                        "phone",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                            ],
                            1
                          ),
                          _c("sui-form-field", { attrs: { width: "six" } }, [
                            _c("label", [_vm._v("Extension")]),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.user.profile.phone_extension,
                                  expression: "user.profile.phone_extension",
                                },
                              ],
                              attrs: {
                                type: "text",
                                name: "phone_extension",
                                placeholder: "Extension",
                              },
                              domProps: {
                                value: _vm.user.profile.phone_extension,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.user.profile,
                                    "phone_extension",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ],
                        1
                      ),
                      _c("sui-form-field", [
                        _c("label", [_vm._v("Fax")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.user.profile.fax,
                              expression: "user.profile.fax",
                            },
                          ],
                          attrs: {
                            type: "text",
                            name: "fax",
                            placeholder: "Fax",
                          },
                          domProps: { value: _vm.user.profile.fax },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.user.profile,
                                "fax",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "sui-grid-row",
                { attrs: { centered: "" } },
                [
                  _c(
                    "sui-grid-column",
                    { attrs: { centered: "", width: "eight" } },
                    [
                      _c("sui-form-field", [
                        _c("label", [_vm._v("Address Line 1")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.user.profile.address_line_1,
                              expression: "user.profile.address_line_1",
                            },
                          ],
                          attrs: {
                            type: "text",
                            name: "address_line_1",
                            placeholder: "Street Address",
                          },
                          domProps: { value: _vm.user.profile.address_line_1 },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.user.profile,
                                "address_line_1",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _c("sui-form-field", { staticClass: "field" }, [
                        _c("label", [_vm._v("Address Line 2")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.user.profile.address_line_2,
                              expression: "user.profile.address_line_2",
                            },
                          ],
                          attrs: {
                            type: "text",
                            name: "address_line_2",
                            placeholder:
                              "C/O, Apt, Suite, Unit, Building, Floor",
                          },
                          domProps: { value: _vm.user.profile.address_line_2 },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.user.profile,
                                "address_line_2",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _c("sui-form-fields", { staticClass: "two fields" }),
                      _c(
                        "sui-form-field",
                        [
                          _c(
                            "sui-form-fields",
                            { attrs: { fields: "two", "equal-width": "" } },
                            [
                              _c("sui-form-field", [
                                _c("label", [_vm._v("City")]),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.user.profile.city,
                                      expression: "user.profile.city",
                                    },
                                  ],
                                  attrs: {
                                    type: "text",
                                    name: "city",
                                    placeholder: "City",
                                  },
                                  domProps: { value: _vm.user.profile.city },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.user.profile,
                                        "city",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                              _c("sui-form-field", [
                                _c("label", [_vm._v("State/Province")]),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.user.profile.state,
                                      expression: "user.profile.state",
                                    },
                                  ],
                                  attrs: {
                                    type: "text",
                                    name: "state",
                                    placeholder: "State/Province",
                                  },
                                  domProps: { value: _vm.user.profile.state },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.user.profile,
                                        "state",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "sui-form-fields",
                        { attrs: { "equal-width": "" } },
                        [
                          _c("sui-form-field", [
                            _c("label", [_vm._v("Zip/Postal Code")]),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.user.profile.zip,
                                  expression: "user.profile.zip",
                                },
                              ],
                              attrs: {
                                type: "text",
                                name: "zip",
                                placeholder: "Zip/Postal Code",
                              },
                              domProps: { value: _vm.user.profile.zip },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.user.profile,
                                    "zip",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _c("sui-form-field", [
                            _c("label", [_vm._v("Country")]),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.user.profile.country,
                                  expression: "user.profile.country",
                                },
                              ],
                              attrs: {
                                type: "text",
                                name: "country",
                                placeholder: "Country",
                              },
                              domProps: { value: _vm.user.profile.country },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.user.profile,
                                    "country",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ],
                        1
                      ),
                      _c("sui-button", {
                        attrs: {
                          type: "button",
                          basic: "",
                          size: "small",
                          content: "Update personal info",
                          color: "blue",
                        },
                        on: { click: _vm.save },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }